import { z } from "zod";

export type Role = {
  id: string;
  nombre: string;
  tipo: "sistema" | "custom";
  descripcion: string | null;
  activo: boolean;
};

export type Permission = {
  id: string;
  codigo: string;
  modulo: string;
  accion: string;
  descripcion: string | null;
};

export type EffectivePermission = {
  codigo: string;
  modulo: string;
  accion: string;
  descripcion: string | null;
  fuente: "rol" | "override_grant" | "override_revoke";
  granted: boolean;
};

export type PermissionOverride = {
  permission_id: string;
  permission_codigo: string;
  permission_modulo: string;
  permission_accion: string;
  granted: boolean;
  motivo: string | null;
  created_at: string;
};

export type User = {
  id: string;
  email: string;
  nombre_completo: string | null;
  rol_id: string | null;
  rol_nombre: string | null;
  activo: boolean;
  password_change_required: boolean;
  last_login_at: string | null;
  tfa_enabled: boolean;
  created_at: string;
};

export type PagedUsers = {
  items: User[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type UserCreatedResponse = {
  user: User;
  password_plaintext: string;
  mensaje: string;
};

export type UsersDashboardStats = {
  total: number;
  activos: number;
  inactivos: number;
  con_2fa: number;
  sin_login_30d: number;
};

// ─── Validación ──────────────────────────────────────────────────────────
export const userCreateSchema = z.object({
  email: z.string().email("Email inválido").max(255),
  nombre_completo: z.string().max(200).optional().or(z.literal("")),
  rol_id: z.string().uuid("Selecciona un rol"),
  password: z.string().min(10, "Mínimo 10 caracteres (mayúscula, minúscula, número y símbolo)").max(128),
  activo: z.boolean().default(true),
  password_change_required: z.boolean().default(true),
});
export type UserCreateInput = z.infer<typeof userCreateSchema>;

export const userUpdateSchema = z.object({
  email: z.string().email("Email inválido").max(255).optional().or(z.literal("")),
  nombre_completo: z.string().max(200).optional().or(z.literal("")),
  rol_id: z.string().uuid().optional().or(z.literal("")),
  activo: z.boolean().optional(),
});
export type UserUpdateInput = z.infer<typeof userUpdateSchema>;

export type PermissionOverrideSet = {
  granted: boolean;
  motivo?: string;
};
